import LoadingPage from "components/LoadingPage";
import InstitucionalSite02 from "pages/SitesInstitucionais/InstitucionalSite02";
import { lazy, Suspense } from "react";

const Sites = lazy(() => import("pages/Sites"));
const SitesInstitucionais = lazy(() => import("pages/SitesInstitucionais"));
const InstitucionalSite01 = lazy(
  () => import("pages/SitesInstitucionais/InstitucionalSite01")
);

const useRoutersSiteInstitucional = () => {
  return [
    {
      path: "/sites-institucionais/",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <SitesInstitucionais />
        </Suspense>
      ),
    },
    {
      path: "/sites-institucionais/1",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <InstitucionalSite01 />
        </Suspense>
      ),
    },
    {
      path: "/sites-institucionais/2",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <InstitucionalSite02 />
        </Suspense>
      ),
    },
    {
      path: "/sites",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <Sites />
        </Suspense>
      ),
    },
  ];
};

export default useRoutersSiteInstitucional;
